import { styled as i } from "styled-components";
const t = i.picture`
  background-image: var(--placeholder-image);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  display: inline-block;
  filter: blur(20px);
  clip-path: border-box;
  transition: filter 0.3s ease-in-out;
  width: 100%;
  height: 100%;

  img {
    opacity: 0;
    object-fit: contain;
  }

  &[data-loading='false'] {
    filter: blur(0);
    background-image: unset;
    img {
      opacity: 1;
    }
  }
`;
export {
  t as Container
};
